import Vue from 'vue'
import Router from 'vue-router'

import HomeComponent from '@/components/Home'

const { PUBLIC_PATH } = process.env

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: PUBLIC_PATH,
  routes: [
    {
      path: '/',
      component: HomeComponent
    }
  ]
})

export default router